export default "__VITE_ASSET__2187197e__"